import axios from "../axios";

interface VantaCacheEntry {
  data: any;
  timestamp: number;
}
const vantaStatusCache = new Map<number, VantaCacheEntry>();
const vantaStatusInFlight = new Map<number, Promise<any>>();
const VANTA_TTL_MS = 60_000;

// Get Vanta connection status for a user (with 60s cache + in-flight deduplication)
export const getVantaStatus = async (userId: number) => {
  const cached = vantaStatusCache.get(userId);
  if (cached && Date.now() - cached.timestamp < VANTA_TTL_MS) {
    return cached.data;
  }

  const inFlight = vantaStatusInFlight.get(userId);
  if (inFlight) {
    return inFlight;
  }

  const promise = (async () => {
    try {
      const res = await axios.get(`/vanta/status/${userId}`);
      vantaStatusCache.set(userId, { data: res.data, timestamp: Date.now() });
      return res.data;
    } finally {
      vantaStatusInFlight.delete(userId);
    }
  })();

  vantaStatusInFlight.set(userId, promise);
  return promise;
};

// Trigger a manual sync (CTB -> Vanta) for the authenticated user (or specific user)
export const triggerVantaSync = async (userId?: number) => {
  if (userId) {
    vantaStatusCache.delete(userId);
  } else {
    vantaStatusCache.clear();
  }
  const url = userId ? `/vanta/sync/trigger/${userId}` : "/vanta/sync/trigger";
  const res = await axios.post(url);
  return res.data;
};


